import { CSSProperties, FC, useState } from 'react';
import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Popover } from '~/commonComponents/Popover/Popover';

// ── inline styles (no DS prop equivalent) ──────────────────────────────────
/** underline has no DS Typography prop */
const levelLinkStyle: CSSProperties = { textDecoration: 'underline' };
/** keeps the popover description on one line; whiteSpace has no DS Typography prop */
const descriptionNowrapStyle: CSSProperties = { whiteSpace: 'nowrap' };

interface IActivityLevelInfoProps {
  activityLevel: string;
  isAvailable?: boolean;
}

const activityLevelDescriptions: Record<string, string> = {
  high: 'Active within the last 30 days',
  medium: 'Active within the last 31-120 days',
  low: 'Active more than 121 days ago',
};

const capitalize = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);

export const ActivityLevelInfo: FC<IActivityLevelInfoProps> = ({
  activityLevel,
  isAvailable = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!activityLevel) {
    return null;
  }

  const textColor = isAvailable ? colors.neutral['500'] : colors.neutral['300'];
  const activeColor = isOpen ? colors.neutral['600'] : textColor;
  const description = activityLevelDescriptions[activityLevel] ?? '';

  const Target = () => (
    <span onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
      <Typography bold color={activeColor} style={levelLinkStyle}>
        {capitalize(activityLevel)}
      </Typography>
    </span>
  );

  const Content = () => (
    <Typography color={colors.neutral['600']} textAlign="center" style={descriptionNowrapStyle}>
      {description}
    </Typography>
  );

  return (
    // dynamic opacity has no DS prop; kept inline for the unavailable state
    <Row align="center" gap={1} style={{ opacity: isAvailable ? 1 : 0.5 }}>
      <Typography color={textColor}>Activity Level: </Typography>
      <Popover Target={Target} Content={Content} trigger="hover" position="bottom" offset={12} />
    </Row>
  );
};
